import { useObjectContext } from '@context/ItemZoneContext'
import { useScrollOnLoad } from '@hooks/useScrollOnLoad'
import { BackMaterialInfo } from '@types'
import { getTextureImage } from '@utils/sceneObjects/getTextureImage'
import clsx from 'clsx'
import { EditorButtons } from '../EditorButtons'

type Props = {
  closeFn: () => void
}

export function TexturesEditor({ closeFn }: Props) {
  const {
    currentTexture,
    rightInfo,
    actions: { handleTextureClick },
  } = useObjectContext()

  const { scrollableEditorRef } = useScrollOnLoad([rightInfo])

  function isSelectedTexture(texture: BackMaterialInfo) {
    if (!currentTexture) return false
    return currentTexture.searchID === texture.idTexturas
  }

  return (
    <div className='flex h-full flex-col flex-wrap p-7'>
      <div className='pb-3 pl-2 text-sm font-semibold text-C/Color3'>{rightInfo.label}</div>
      <div
        ref={scrollableEditorRef}
        className='scrollable-editor flex max-h-[540px] flex-wrap gap-x-5 gap-y-9 overflow-x-hidden overflow-y-scroll p-2'
      >
        {rightInfo.textures.map((texture: BackMaterialInfo) => {
          return (
            <div
              key={`${texture.idTexturas}`}
              className='flex max-h-44 flex-col'
            >
              <img
                role='button'
                loading='lazy'
                src={getTextureImage(texture)}
                onClick={() => handleTextureClick(texture)}
                className={clsx(
                  'h-32 w-32 cursor-pointer',
                  isSelectedTexture(texture) &&
                    'selected elElegido outline outline-4 outline-C/Color6',
                )}
              />
              <div
                className={clsx(
                  'mt-1 flex w-32 text-xs ',
                  isSelectedTexture(texture) && 'font-extrabold',
                )}
              >
                <span>({texture.identificadorTextura})</span>
              </div>
              <span
                className='text-xs'
                style={{
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  maxWidth: '125px',
                  display: 'inline-block',
                }}
              >
                {texture.nombre}
              </span>
            </div>
          )
        })}
      </div>
      <EditorButtons closeFn={closeFn} />
    </div>
  )
}
